import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(
  '40fba8cb9a2c4d60509d30411b6d7469Tz0xMjA4MTAsRT0xNzkyODg2Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

export const MuiXLicense = () => {
  return null
}
